import React from 'react'
import { SignIn, SignUp } from "@clerk/clerk-react";
export default function SignInTest() {
  return (
    <div><SignIn /></div>
  )
}
